import { TrackingEvent } from '@y42/user-tracking-legacy';

export class SessionDurationTrackingEventModel extends TrackingEvent<
  Partial<{
    sessionDuration: string;
  }>
> {
  readonly name = 'Session Duration';
}
